import { debounce } from 'lodash';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setProvider, updateProps } from '../../../contextRedux/Provider/ProviderModel';
import { SearchInput } from '../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../customComponents/table/CustomTable';
import { RootState } from '../../../store';
import { ProviderColumn } from './ProviderColumn';

const ProviderTable: FC = () => {
  const dispatch = useDispatch();
  const reduxProvider = useSelector((state: RootState) => state.models?.provider);
  const providers = useSelector((state: RootState) => state.store?.provider.data ?? []);

  const pageSizes = [10, 20, 30, 50];
  const currentPage = Math.floor(reduxProvider.props.skip / reduxProvider.props.take) + 1;

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch(updateProps({ field: 'searchTerm', value }));
      dispatch(updateProps({ field: 'skip', value: 0 }));
    }, 500),
    [dispatch]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const handleEdit = (record: any) => {
    dispatch(setProvider(record));
    dispatch(updateProps({ field: 'isModalVisible', value: true }));
  };

  const paginationConfig = {
    current: currentPage,
    pageSize: reduxProvider.props.take,
    total: reduxProvider.props.totalItems,
    onChange: (page: number, pageSize: number) => {
      const skipValue = (page - 1) * pageSize;
      dispatch(updateProps({ field: 'skip', value: skipValue }));
      dispatch(updateProps({ field: 'take', value: pageSize }));
    },
    showSizeChanger: true,
    pageSizeOptions: pageSizes.map((size) => size.toString()),
    onShowSizeChange: (_current: number, size: number) => {
      dispatch(updateProps({ field: 'skip', value: 0 }));
      dispatch(updateProps({ field: 'take', value: size }));
    },
    showQuickJumper: false,
  };

  return (
    <div>
      <SearchInput
        placeholder='Search...'
        defaultValue={reduxProvider.props.searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 10 }}
      />
      <CustomTable
        initialDataSource={providers}
        pagination={paginationConfig}
        columns={ProviderColumn(handleEdit)}
        rowKey='id'
      />
    </div>
  );
};
export default ProviderTable;
